import { create } from 'zustand';

type StoreState = {
  isIdSelected: (id: string) => boolean;
  isStoreEmpty: () => boolean;
  removeId: (id?: string) => void;
  selectedIds: Set<string>;
  selectId: (id: string | string[]) => void;
  toggleId: (id: string) => void;
};

export const perkSelectStore = create<StoreState>()((set, get) => ({
  selectedIds: new Set<string>(),

  removeId: (id) => {
    if (!id) {
      set({ selectedIds: new Set() });
      return;
    }

    const next = new Set(get().selectedIds);
    next.delete(id);

    set({ selectedIds: next });
  },

  toggleId: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      next.has(id) ? next.delete(id) : next.add(id);
      return { selectedIds: next };
    }),

  isIdSelected: (id) => {
    const store = get().selectedIds;
    return store.has(id);
  },

  isStoreEmpty: () => {
    const store = get().selectedIds;
    return !store.size;
  },

  selectId: (id) => {
    if (Array.isArray(id)) {
      set({ selectedIds: new Set(id) });
      return;
    }

    const next = new Set(get().selectedIds);
    next.add(id);

    set({ selectedIds: next });
  },
}));
